import { createFileRoute } from '@tanstack/react-router';
import { InicioPage } from '../../inicio/inicio-page.tsx';

export const Route = createFileRoute('/inicio')({
  component: InicioPage,
});
